<ng-container [formGroup]="newEditForm">
    <td class="short" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="paises" [selectedItem]="newEditForm.get('pais')" [disabled]="disabledPais" [placeHolder]="false"></app-filterable-list>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="denominaciones" [selectedItem]="newEditForm.get('denominacion')" [disabled]="disabledDenominacion" [placeHolder]="false"></app-filterable-list>
    </td>
    <td class="multi-actions">
        <ng-container *ngIf="editable">
            <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
            <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" *ngIf="this.role === 'Administrador' || this.claims.includes('PROD_PD_Del')"
               [ngClass]="{'disabled': (registroEnUso)}" app-click-stop-propagation (click)="askDelete(paisDenominacion)"></i>
        </ng-container>
    </td>
</ng-container>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{'global.eliminar.descripcion' | translate}}</h4>
      </header>
      <content>
        <p>{{'global.eliminar.confirmacion' | translate}}</p>
      </content>
      <footer>
        <button class="secondary" (click)="closeModal()">{{'global.cancelar' | translate}}</button>
        <button (click)="delete()">{{'global.confirmar' | translate}}</button>
      </footer>
    </div>
</div>